export const extensionRoutes = [  {
    path: 'extensions/dashboard/active-clients',
    loadChildren: () => import('./extensions/active-clients-dashboard/active-clients-dashboard.module').then(m => m.ActiveClientsDashboardModule),
  },
  {
    path: 'extensions/work-brands',
    loadChildren: () => import('./extensions/work-brands/routes'),
  },
  {
    path: 'extensions/banners',
    loadChildren: () => import('./extensions/banner/routes'),
  },
  {
    path: 'extensions/partners',
    loadChildren: () => import('./extensions/partner/partner.module').then(m => m.PartnersModule),
  },
  {
    path: 'extensions/sellers',
    loadChildren: () => import('./extensions/sellers/sellers.module').then(m => m.SellersModule),
  },
  {
    path: 'extensions/synonyms',
    loadChildren: () => import('./extensions/synonym/synonym-group.module').then(m => m.SynonymGroupModule),
  },
  {
    path: 'extensions/search-stats',
    loadChildren: () => import('./extensions/search-stats/search-stats.module').then(m => m.SearchStatsModule),
  },
  {
    path: 'extensions/assisted-sales',
    loadChildren: () => import('./extensions/assisted-sales/assisted-sales.module').then(m => m.AssistedSalesModule),
  },
  {
    path: 'extensions/received-orders',
    loadChildren: () => import('./extensions/received-orders/routes'),
  },
  {
    path: 'extensions/suggested-orders',
    loadChildren: () => import('./extensions/suggested-orders/routes'),
  },
  {
    path: 'extensions/system-events',
    loadChildren: () => import('./extensions/system-events/routes'),
  },
  {
    path: 'extensions/landing-pages',
    loadChildren: () => import('./extensions/landing-page/landing-page.module').then(m => m.LandingPageModule),
  },
  {
    path: 'extensions/product-carousels',
    loadChildren: () => import('./extensions/product-carousel/product-carousel.module').then(m => m.ProductCarouselModule),
  },
  {
    path: 'extensions/merge-audit-logs',
    loadChildren: () => import('./extensions/merge-audit-log/merge-audit-log.module').then(m => m.MergeAuditLogModule),
  },
  {
    path: 'extensions/orphan-variants',
    loadChildren: () => import('./extensions/orphan-variants/orphan-variants.module').then(m => m.OrphanVariantsModule),
  },
  {
    path: 'extensions/social',
    loadChildren: () => import('./extensions/channel-social-media/channel-social-media.module').then(m => m.ChannelSocialMediaModule),
  },
  {
    path: 'extensions/shopping-list',
    loadChildren: () => import('./extensions/shopping-list/shopping-list.module').then(m => m.ShoppingListModule),
  },
  {
    path: 'extensions/webhook',
    loadChildren: () => import('./extensions/de46ce88b565373af4d5d8bd724ae0280225e864c9508fdeeed2e0aafd7bfe13/webhook.module').then(m => m.WebhookModule),
  },
  {
    path: 'extensions/export-orders',
    loadChildren: () => import('./extensions/04aeffc4d152e9bcc290ae18ed3d9225a9c4f4310f07012706247c83f7022261/order-export.module').then(m => m.OrderExportModule),
  },
  {
    path: 'extensions/survey',
    loadChildren: () => import('./extensions/survey/routes'),
  }];
